import { useState } from "react";
import { post } from "../networking/RequestService";

const useTaskImportant = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const toggleTaskImportant = async (taskId, currentImportant) => {
        setLoading(true);
        setError(null);
        try {
            const payload = {
                fn: "taskImportant",
                gorev: taskId,
                important: currentImportant ? 0 : 1,
            };

            const response = await post(payload);
            return response;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { toggleTaskImportant, loading, error };
};

export default useTaskImportant;
